import { useState } from "react";
import AuthLayout from "../../blocs/AuthLayout";
import TextInput from "../../components/inputs/TextInuput";
import PasswordInput from "../../components/inputs/PasswordInput";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonT from "../../components/ButtonTwyny";
import { toast } from "react-toastify";

const NewPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  let email = location?.state?.email;
  let code = location?.state?.code;
  const [password, setPassword] = useState(null);
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const validateCode = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}reset-password`,
        {
          email,
          code,
          password,
          password_confirmation: password,
        }
      );
      if (response) navigate("/login"); // Redirect to login
    } catch (err) {
      const errorMessage = err.response?.data?.error || "Échec de la connexion";
      toast.error(errorMessage);
    }
  };
  return (
    <>
      <AuthLayout
        image="../images/prestaLeftImg.png"
        title="Réservez tous vos <strong>services pros </strong>, quand et où vous voulez."
      >
        <div className="col-md-8 mx-auto">
          <h3 className="grey500 text-center">Nouveau mot de passe</h3>
          <p className="body grey66 mt-16">
            Créez votre nouveau mot de passe.{" "}
          </p>
          {/* Password Field */}
          <div className="input-wrapper password mt-16">
            <label className="form-label">Mot de passe*</label>
            <div className="password-input-wrapper">
              <input
                name="password"
                type={isVisible ? "text" : "password"} // Toggle between text and password
                // as={PasswordInput}
                // className={`${touched.password && errors.password ? 'is-invalid' : ''}`}
                placeholder="Nouveau mot de passe"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
              <span className="visibility-toggle" onClick={toggleVisibility}>
                <img
                  src={
                    isVisible
                      ? "/images/eye-closed.svg"
                      : "/images/eye-open.png"
                  }
                  alt="eye toggle"
                  width={24}
                  height={24}
                />
              </span>
            </div>
            {/* <ErrorMessage name="password">
                                          {(msg) => (
                                            <div className="error-message mt-8">
                                              <img src="/images/alert-circle.svg" className="arrow mr-8" alt="Arrow" />
                                              {msg}
                                            </div>
                                          )}
                                        </ErrorMessage> */}

            <span className="mt-8 legend grey66">
              Le mot de passe doit faire plus de 8 caractères
            </span>
          </div>
          {/* <PasswordInput
            label="Mot de passe"
            required
            placeholder="Nouveau mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            isRegistration={true}
          /> */}
          <ButtonT
            onclickFn={validateCode}
            disabled={!password}
            ctaText={"Terminer"}
            className="twyny-cta-primary w-100 mt-24"
          ></ButtonT>
        </div>
      </AuthLayout>
    </>
  );
};
export default NewPassword;
